import React from 'react';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import { Row } from '@thd-olt-component-react/grid';
import { bool } from 'prop-types';
import './loader.scss';

export const Loader = (props) => {
  const { large } = props;

  return (
    <div className="super-sku-loading-container">
      Loading Options
      {large
        ? (
          <>
            <LoadingPlaceholder
              className="super-sku-loading__text-row"
              type="textRow"
              showLoadingAnimation
              rows={1}
              style={{ width: '35%' }}
            />
            <Row>
              <LoadingPlaceholder
                className="super-sku-loading__rectangle"
                type="rect"
                showLoadingAnimation
                style={{ height: 120, width: 120 }}
              />
              <LoadingPlaceholder
                className="super-sku-loading__rectangle"
                type="rect"
                showLoadingAnimation
                style={{ height: 120, width: 120 }}
              />
            </Row>
            <LoadingPlaceholder
              className="super-sku-loading__text-row"
              type="textRow"
              showLoadingAnimation
              rows={1}
              style={{ width: '35%' }}
            />
            <Row>
              <LoadingPlaceholder
                className="super-sku-loading__rectangle"
                type="rect"
                showLoadingAnimation
                style={{ height: 120, width: 120 }}
              />
              <LoadingPlaceholder
                className="super-sku-loading__rectangle"
                type="rect"
                showLoadingAnimation
                style={{ height: 120, width: 120 }}
              />
            </Row>
          </>
        )
        : (
          <div className="super-sku-loading-wrapper">
            <span className="segment-spinner segment-spinner" />
            <div className="loading-tile-wrapper">
              <div className="loading-tile" />
              <div className="loading-tile" />
              <div className="loading-tile" />
              <div className="loading-tile" />
              <div className="loading-tile" />
              <div className="loading-tile loading-tile--last" />
            </div>
          </div>
        )}
    </div>
  );
};

Loader.displayName = 'SuperSkuLoader';

Loader.propTypes = {
  large: bool,
};

Loader.defaultProps = {
  large: false,
};
